import { RBACAccessLevel, RBACDomain } from "@/access-control/types";
import { AccessResult } from "@/hooks/useUserHasAccess";
import useUsers from "@/hooks/useUsers";
import usePermissions from "@/access-control/queries/usePermissions";
import { userHasAccess } from "@/access-control/permissions";

export function useUserHasAccessToAny(
  domain: RBACDomain,
  ...accessLevels: RBACAccessLevel[]
): AccessResult {
  const usersState = useUsers();
  const { data: rolePermissions, isLoading: permsLoading } = usePermissions();

  if (permsLoading || usersState.loading) {
    return null;
  }

  for (const accessLevel of accessLevels) {
    if (
      userHasAccess(
        usersState.currentUser,
        rolePermissions,
        domain,
        accessLevel,
      )
    ) {
      return true;
    }
  }

  return false;
}
